<app-paginated-table [paginationResponseResolver]="paginationResponseResolver()"
  [defaultPaginationParameters]="defaultPaginationParameters()" [supportedActions]="supportedActions()"
  [tableConfig]="finalTableConfig()" (actionExecuted)="onActionExecuted($event)" />

<ng-template #tableRowTemplate let-element>
  <td>#{{ element.autoIncrementalId }}</td>
  <ng-container *ngIf="tableConfig()?.template; else defaultTemplate">
    <ng-container *ngTemplateOutlet="tableConfig()!.template; context: { $implicit: element }"></ng-container>
  </ng-container>
  <ng-template #defaultTemplate let-element></ng-template>
  <!-- <td>
    <span *ngIf="element.isActive; else inactive" class="badge badge-success">{{"GENERAL.ACTIVE" | translate}}</span>
    <ng-template #inactive>
      <span class="badge badge-danger">{{"GENERAL.INACTIVE" | translate}}</span>
    </ng-template>
  </td> -->
  <td>
    @if (element?.isActive) {
    <span class="active-status">
      <i class="pi pi-check"></i>
    </span>
    } @else {
    <span class="inactive-status"></span>
    }
  </td>
</ng-template>
